import { useToast, UseToastOptions } from "@chakra-ui/react";
import { useCallback } from "react";
import { errorToToastOptions } from "../api/errors/errorToToastOptions";

/**
 * Raise a toast to display an error message.
 */
export function useReportError() {
  const toast = useToast();

  return useCallback(
    (error: unknown, overrides?: UseToastOptions) => {
      const options = errorToToastOptions(error);

      toast({
        ...options,
        ...overrides,
      });
    },
    [toast],
  );
}
